// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import PageContentBlock from '../../internal/PageContentBlock';
import FormattedContent from '../../internal/FormattedContent';
import type { CompleteRichText } from '../../internal/types';

type PropTypes = {|
  number: number,
  title: string,
  children: CompleteRichText,
|};

const NumberedContent = (props: PropTypes) => {
  return (
    <PageContentBlock layout="Thin">
      <div className={styles.numberedContent}>
        <span className={styles.number}>{props.number}</span>
        <div className={styles.container}>
          <span className={styles.numberMobile}>{props.number}</span>
          <h2 className={styles.title}>{props.title}</h2>
          <FormattedContent className={styles.text} variant="Secondary">
            {props.children}
          </FormattedContent>
        </div>
      </div>
    </PageContentBlock>
  );
};

export default NumberedContent;
